<template>
  <div class="product-section" style="padding: 20px">
    <a-space style="margin-bottom: 10px" class="df">
      <a-date-picker
        v-model:value="requestPayload.localDate"
        @change="updateTable"
        style="width: 200px"
        allowClear
      >
      </a-date-picker>
      <a-input
        placeholder="机身号"
        @change="handleSearch"
        v-model:value="requestPayload.serial"
        style="width: 200px"
        allowClear
      ></a-input>
    </a-space>
    <a-table
      :data-source="table.data"
      bordered
      :pagination="false"
      :columns="columns"
      rowKey="id"
      :scroll="{ y: 'calc(100vh - 300px)' }"
    >
      <template #filePath="{ record }">
        <a-button
          type="primary"
          size="small"
          v-if="record.filePath"
          @click="handleDownLoadFile(record.filePath)"
        >
          下载
        </a-button>
      </template>
    </a-table>
  </div>
</template>

<script>
import { defineComponent, watch, inject } from "vue";
import { useTable } from "@/views/notice/serve/table";
import {
  getBackupFileList,
  updateBackupFile,
} from "@/request/view/qualityInspection";
import { useRouter } from "vue-router";
import { debounce, timeStampToTime, Toast } from "@/utils";
import { showModal } from "@/views/repairprogress/serve/modal";
import { download } from "@/views/rdmanagement/serve/index";

export default defineComponent({
  setup() {
    const router = useRouter();

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    initPayload({
      localDate: null,
      serial: null,
      type: 1,
    });

    const columns = [
      {
        title: "机身号",
        dataIndex: "serial",
        align: "center",
      },
      {
        title: "上传时间",
        dataIndex: "localDate",
        align: "center",
      },
      {
        title: "上传次数",
        dataIndex: "uploadNumber",
        align: "center",
      },
      {
        title: "文件",
        dataIndex: "filePath",
        align: "center",
        slots: {
          customRender: "filePath",
        },
      },
    ];

    requestConfig.pull_fn = getBackupFileList;

    const handleUpdateFile = (record) => {
      showModal({
        title: "提示",
        toastText: "确认清空文件？",
        success: () => {
          updateBackupFile(record.id)
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              getListData({ unPagingRequest: true });
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const getData = () => {
      getListData({ unPagingRequest: true });
    };

    const cascadeDate = inject("cascadeDate", null);

    const handleDownLoadFile = (file) => {
      download(file, "下载");
    };

    const handleSearch = debounce(() => {
      getData();
    }, 200);

    const updateTable = (e, stringDate) => {
      requestPayload.localDate = stringDate;
      handleSearch();
    };

    getData();

    return {
      table,
      columns,
      handleSearch,
      getData,
      updateTable,
      requestPayload,
      handleDownLoadFile,
      handleUpdateFile,
    };
  },
});
</script>

<style lang="less" scoped>
.product-section {
  border-radius: 20px;
  box-shadow: 0 0 10px 0 #ccc;
  padding: 20px 0;
  height: calc(100vh - 120px);
  margin: 0px auto;
  background: #fff;
  .title {
    font-size: 20px;
    font-weight: bold;
    width: 300px;
  }
}
</style>
